module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAlBAMAAAC0dAQLAAAALVBMVEUAAABUe/dUe/dUe/dUe/dUe/dUe/dUe/dUe/dUe/dUe/dUe/dUe/dUe/dUe/f5DeBlAAAADnRSTlMABKF6rbhwhQENZ5XHU1TXopIAAACBSURBVBjTY4ABjssT4OymdwdgTEa9dw9gbKF37wwQws+RhAtgwn7vHsOERYCqCQjHIYRF371LQAg/wyLMiSQ89d27BTDhc+9ewYRZEMIMfO8ewf3DhDAFYTrCeEwJhCsRricsUcCAJXQYhHBJNCFJcOxDkuhGlXiAJHGAAQ5uTQAAELNSqVO8ZdkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jian.png
// module id = csbO
// module chunks = 0